import { useQuery } from "@tanstack/react-query";
import { insightsApi } from "../api";
import type { StandardInsightsQueryParams } from "../api";

const buildQueryKey = (params: StandardInsightsQueryParams) => {
  return ["admin", "insights", "standard", JSON.stringify(params)] as const;
};

export const useStandardInsights = (
  params: StandardInsightsQueryParams,
  options?: { enabled?: boolean }
) => {
  return useQuery({
    queryKey: buildQueryKey(params),
    queryFn: () => insightsApi.getStandardInsights(params),
    enabled: options?.enabled ?? true,
    retry: false,
  });
};
